/** Language parsing shared by the UI and non-JSX tests. English is the default. */
export type Lang = 'en' | 'zh-CN'
export function parseLang(value: string | null | undefined): Lang | null {
  const raw = (value ?? '').trim().toLowerCase().replace('_', '-')
  if (raw === 'en') return 'en'
  if (raw === 'zh' || raw === 'zh-cn' || raw === 'zh-hans') return 'zh-CN'
  return null
}
